import { jSocialEventListSchema } from './socialEvent';
import { jArticleViewSchema } from './article';
import { z } from 'zod';

export const jMeetingListSchema = jSocialEventListSchema.extend({});
export type jMeetingList = z.infer<typeof jMeetingListSchema>;

export const ensureIsMeetingList = (o: unknown): o is jMeetingList => {
    return jMeetingListSchema.safeParse(o).success;
};

export const jMeetingViewSchema = jArticleViewSchema.and(jMeetingListSchema).and(
    z.object({
        allDay: z.null(), // TODO
        agenda: z.string(),
        useQrcode: z.null(), // TODO
        textColor: z.string(),
        bgColor: z.string(),
        report: z.string(),
        reportFile: z.array(z.never()),
        urlGestion: z.string().nullable().optional(),
        webinarUrlForGuests: z.string().optional().nullable(),
    }),
);
export type jMeetingView = z.infer<typeof jMeetingViewSchema>;
